"use strict";

import { initialise_animations } from "./animations.js";

initialise_animations("animate");

{
	const html = document.querySelector("html");
	if (html instanceof Element) {
		/** Detect Esc key */
		document.addEventListener("keydown", (event) => {
			if (event.key === "Escape") {
				html.classList.remove("html-no-scroll");
				html.classList.remove("header-burger-active");
			}
		});

		/** Burger menu */
		{
			const burger = document.querySelector("#header-burger"),
				not_burger = document.querySelector("#header-lightbox");
			if (burger instanceof Element) {
				burger.addEventListener("click", (_) => {
					html.classList.toggle("header-burger-active");
					html.classList.toggle("html-no-scroll");
				});
			}
			if (not_burger instanceof Element) {
				not_burger.addEventListener("click", (_) => {
					html.classList.remove("header-burger-active");
					html.classList.remove("html-no-scroll");
				});
			}
		}

		/** Header search modal */
		{
			const header_open_search = document.querySelector("#header-open-search"),
				header_search_modal = document.querySelector("#header-search-modal");
			if (html instanceof Element && header_open_search instanceof Element && header_search_modal instanceof HTMLDialogElement) {
				header_open_search.addEventListener("click", (_) => {
					header_search_modal.showModal();
					html.classList.add("html-no-scroll");
				});
				header_search_modal.addEventListener("click", ({ target: dialog }) => {
					if (dialog.nodeName === "DIALOG") {
						dialog.close();
						html.classList.remove("html-no-scroll");
					}
				});
			}
		}
	}

	/** Hide on scroll. */
	{
		const breakpoint = 1024,
			header_height_mobile = 99,
			header_height_desktop = 129,
			hide_on_scroll_elements = document.querySelectorAll(".hide-on-scroll");
		const header_height_fn = () => (window.screen.width < breakpoint ? header_height_mobile : header_height_desktop);
		if (hide_on_scroll_elements instanceof NodeList) {
			let scroll_y = window.scrollY;
			window.addEventListener("scroll", (_) => {
				const header_height = header_height_fn();
				hide_on_scroll_elements.forEach((hide_on_scroll) => {
					if (window.scrollY > scroll_y && window.scrollY > header_height) {
						hide_on_scroll.classList.add("hide");
					} else {
						hide_on_scroll.classList.remove("hide");
					}
				});
				scroll_y = window.scrollY;
			});
		}
	}

	/** Toggles */
	{
		const body = document.querySelector("body"),
			toggle_containers = document.querySelectorAll(".toggle-container");
		if (body instanceof Element) {
			toggle_containers.forEach((toggle_container) => {
				if (toggle_container instanceof Element) {
					const toggle = toggle_container.querySelector(".toggle");
					if (toggle instanceof Element) {
						toggle.addEventListener("click", (_) => {
							if (!toggle.classList.contains("active")) {
								toggle.classList.add("active");
							} else {
								toggle.classList.remove("active");
							}
						});
						body.addEventListener("click", (event) => {
							const target = event?.target;
							if (target instanceof Element && !toggle_container.contains(target)) {
								toggle.classList.remove("active");
							}
						});
					}
				}
			});
		}
	}

	/** Sub-menu scrolls */
	{
		document.querySelectorAll(".group\\/menu-desktop")?.forEach((menu) => {
			menu.querySelectorAll(".sub-menu")?.forEach((sub_menu) => {
				sub_menu.addEventListener("transitionstart", (event) => {
					if (event instanceof TransitionEvent && event.propertyName === "max-height") {
						sub_menu.classList.remove("!overflow-y-auto");
					}
				});
				sub_menu.addEventListener("transitionend", (event) => {
					if (event instanceof TransitionEvent && event.propertyName === "max-height") {
						sub_menu.classList.add("!overflow-y-auto");
					}
				});
			});
		});
	}
}
